import { render } from "./TabDashboard.vue?vue&type=template&id=b37ebc32"
import script from "./TabDashboard.js?vue&type=script&lang=js"
export * from "./TabDashboard.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__